import _ from 'lodash';

import { danger } from '../utils';

// Validation ----------------------------------------------------------------------

export const twoDecimalValidation = (value: any) => {
  if (!value) return true;
  return /^\d+(\.\d{1,2})?$/.test(value);
}

export const isNumeric = (value: any) => {
  return !isNaN(parseFloat(value)) && isFinite(value)
}

export const getFirstError = (err: any) => {
  if (!err) {
      danger('Error', 'You must fill in the required fields');
      return;
  }
  if (typeof err === 'string' && err.trim()) {
      danger('Error', err);
      return;
  }
  if (Array.isArray(err)) {
      for (const item of err) {
          if (item) {
              getFirstError(item);
              return;
          }
      }
  } else if (typeof err === 'object') {
      for (const key in err) {
          if (Object.prototype.hasOwnProperty.call(err, key)) {
              if (err[key]) {
                  getFirstError(err[key]);
                  return;
              }
          }
      }
  }
  // Ako ništa nije pronađeno, default poruka
  danger('Error', 'You must fill in the required fields');
}